import { lastValueFrom } from 'rxjs';
import { BaseService } from './base-service';
export class IngredientStockService {
    static getIngredientStock(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return lastValueFrom(BaseService.getPaginated(`ingredient-stock?filter=${qs}`, pageNumber));
    }
    static fetchIngredientStock(oid) {
        return lastValueFrom(BaseService.get(`ingredient-stock/${oid}`));
    }
    static saveIngredientStock(dto) {
        return lastValueFrom(BaseService.save(`ingredient-stock`, dto));
    }
    static deleteIngredientStock(oid) {
        return lastValueFrom(BaseService.delete(`ingredient-stock/${oid}`));
    }
    static searchIngredientStockCombo(selfId, search) {
        let qs = encodeURIComponent(search);
        return lastValueFrom(BaseService.get(`ingredient-stock-search-dropdown/${selfId}?search=${qs}`));
    }
}
